export default {"src":"/_next/static/media/keypadWithFinger_24.3188c5bf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};